<template>
  <div id="app">
    <template v-if="showRestaurant">
      <Header
				v-show="$route.name && $route.name !== 'Paymentstatus'"
				ref="headerRef"
				class="w-full max-w-[87.5rem] mx-auto"
      />
			<CategoriesCarousel
				v-if="$store.getters.categories.length && $store.state.isCategoryCarouselShown"
				ref="categoryCarouselRef"
				class="w-full max-w-[87.5rem] mx-auto"
				:delay="500"
			/>
			<div class="relative flex-grow-1">
				<transition
					name="page-slide-up"
					mode="in-out"
				>
					<!-- page is absolute because page animation is shown over previous page -->
					<div
						:key="$route.matched[0]?.name === 'Checkout' ? 'Checkout' : $route.name"
						class="absolute top-0 left-0 w-full h-full bg-gray-secondary"
					>
						<!-- scrolled content must be relative for popper to stay in its position after scroll -->
						<main
							ref="mainRef"
							id="relative-scrollable-content"
							class="relative w-full h-full overflow-y-auto"
						>
							<p
								v-if="!isPaymentStatus && !$store.getters.restaurantSlug"
								class="text-center mt-20 font-semibold"
							>
								{{$t("We were unable to find your restaurant. Please enter the correct URL")}}
							</p>
							<template v-else>
								<div
									class="pt-4 w-full mx-auto max-w-[87.5rem]"
									:class="[
										['Checkout', 'Basket'].includes($route.name) ? 'pb-[7.5rem] sm:pb-20' : 'pb-20',
										$route.name === 'Basket' ? 'h-full px-3' : 'px-4'
									]"
								>
									<router-view ref="routerViewRef"/>
								</div>
								<LegalDialog />
							</template>
						</main>
					</div>
				</transition>
			</div>
    </template>

		<div>
			<loading
				:is-loading="isLoading || !showRestaurant"
				:color="showRestaurant ? undefined : 'rgb(var(--twc-gray-disabled-variant)'"
			/>
		</div>

		<div id="portal"></div>
  </div>
</template>

<script>
import themes from '../themes.json';
const Header = () => import("@/components/Header.vue");
const Loading = () => import("@/components/Loading.vue");
const CategoriesCarousel = () => import("@/components/CategoriesCarousel.vue");
const LegalDialog = () => import('@/components/LegalDialog.vue');

const urlParts = window.location.pathname.split("/");
const lastURLPart = urlParts[urlParts.length - 1].split('?')[0];

export default {
  components: { Header, Loading, CategoriesCarousel, LegalDialog },
  data() {
    return {
      // showPayOptions: true,
      isLoading: false,
      showRestaurant: false,
      registration: null,
      updateExists: false,
      fetchedLocales: {},
    };
  },
  watch: {
		"$i18n.locale": {
			immediate: false,
			handler(newVal){
				if(!newVal) return;
        localStorage.setItem("defaultLocale", newVal);
        document.documentElement.lang = newVal;
        window.moneyLang = newVal;
        if (this.restaurantId) this.getLocales(newVal);
			}
    },
    "$store.getters.restaurantInfo.id": {
			immediate: true,
			handler(newVal) {
				if (!newVal) return;
        let locale = document.documentElement.lang || localStorage.getItem('defaultLocale') || "de";
        this.getLocales(locale);
			}
		},
		"$store.getters.restaurantInfo.currency": {
			immediate: true,
			handler(newVal) {
				if (!newVal) return;
				let result = ''
				if (newVal === '€') result = 'EUR';
				else if (newVal === 'CHF') result = 'CHF';
				else if (newVal === '$') result = 'USD';
				window.moneyCurrency = result;
			}
		},
    faveIcon: {
      immediate: true,
      handler() {
        this.changeFavicon()
      }
    },
    "$store.state.orderiomApiPackage.restaurant.restaurantInfo.customDesign"(newVal) {
      if(!newVal) return;

			newVal.primary_color && this.$setPrimaryColors(newVal.primary_color)

			const themeName = newVal.is_dark ? 'dark' : 'light';
			Object.entries(themes[themeName]).forEach(([name, hex]) => this.$setColor(name, hex))
			this.$store.dispatch('setIsDark', !!newVal.is_dark)
    },
  },
  computed: {
    restaurantId() {
      return this.$store.state.orderiomApiPackage.restaurant.restaurantId;
    },
    faveIcon() {
      return this.$store.state.orderiomApiPackage.restaurant.restaurantInfo
        .favicon;
    },
    storage() {
      return process.env.VUE_APP_S3_STORAGE;
    },
    logo(){
      return this.$store.state.orderiomApiPackage.restaurant.restaurantInfo.logo
    },
    language(){
      return this.$store.state.orderiomApiPackage.restaurant.restaurantInfo.lang
    },
		isPaymentStatus(){
			return urlParts.includes('paymentstatus');
		}
  },
  methods: {
    // goOnline() {
    //   this.showRestaurant = true,
    //   this.showPayOptions = false
    //   this.showHeader= true
    // },
    // goForScan(){
    //   this.showRestaurant = false,
    //   this.showPayOptions = false
    //   this.showHeader = false,
    //   this.tableMode= true
    //   this.$router.push('/table-pay')
    // },
    getLocales(locale) {
      if (!locale || this.fetchedLocales[locale]) return;
      return this.$http.get('api/restaurant/locales?lang=' + locale).then(resp => {
        this.$i18n.mergeLocaleMessage(locale, resp.data);
        this.fetchedLocales[locale] = true;
        this.$i18n.locale = '';
        this.$i18n.locale = locale;
      });
    },
    enableInterceptor() {
      this.$http.interceptors.request.use(
        (config) => {
          this.isLoading = true;
          return config;
        },
        (error) => {
          this.isLoading = false;
          return Promise.reject(error);
        }
      );

      this.$http.interceptors.response.use(
        (response) => {
          this.isLoading = false;
          return response;
        },
        (error) => {
          this.isLoading = false;
          return Promise.reject(error);
        }
      );
    },
    changeFavicon() {
      if (this.faveIcon) {
        var link = document.querySelector("link[rel~='icon']");
        if (!link) {
          link = document.createElement("link");
          link.rel = "icon";
          document.head.appendChild(link);
        }
        link.href = this.storage + this.faveIcon;
      }
    },
    async updateAvailable(event) {
			console.log('Deleting older caches of index.html...');
			await this.$store.dispatch('restaurant/deleteOlderIndexCaches');
			console.log('Completed deleting older caches of index.html');

      this.registration = event.detail
      this.updateExists = true
      this.$swal({
        title: this.$t("we have updates! please refresh."),
        showClass: {
          popup: "swal2-show md-warning",
        },
      }).then(res => {
        if (res.isConfirmed) {
          this.refreshApp()
        }
      })
    },
    refreshApp() {
      this.updateExists = false
      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (!this.registration || !this.registration.waiting) return
      // Send message to SW to skip the waiting and activate the new SW
      this.registration.waiting.postMessage({ type: 'SKIP_WAITING' });
			window.location.reload();
    },
    createMetaTags(){
      // NOTE: It is not recommended to set meta tags client side
      // NOTE: some values need to be changed like og:image
      const data = this.$store.getters.restaurantInfo;
      const description = `Willkommen bei ${data.name}, wo wir ein köstliches kulinarisches Erlebnis mit einer großen Auswahl an leckeren Gerichten bieten. Genießen Sie unseren erstklassigen Service, die gemütliche Atmosphäre und die außergewöhnliche Küche, die alle Geschmäcker anspricht. Besuchen Sie noch heute ${data.name} und kosten Sie die Aromen, die uns bei Feinschmeckern beliebt machen.`
      const title = `Ordermood | ${data.name}`;

      const tags = [
        // opengraph
        {type: 'property', field: 'og:type', content: 'website' },
        {type: 'property', field: 'og:site_name', content: data.name },
        {type: 'property', field: 'og:title', content: title },
        {type: 'property', field: 'og:image', content: data.logo ? this.$storage + data.logo : null },
        // {type: 'property', field: 'og:url', content: '' },
        {type: 'property', field: 'og:description', content: description },

        // Twitter
        {type: 'name', field: 'twitter:card', content: data.logo ? 'summary_large_image' : 'summary' },
        {type: 'name', field: 'twitter:title', content: title },
        {type: 'name', field: 'twitter:description', content: description },
        {type: 'name', field: 'twitter:image', content: data.logo ? this.$storage + data.logo : null },

        // Meta
        {type: 'name', field: 'description', content: description}
      ];

      document.title = title
      tags.forEach(tag => {
        if(!tag.content) return;
        const meta = document.createElement('meta');
        meta.setAttribute(tag.type, tag.field)
        meta.content = tag.content;
        document.head.appendChild(meta);
      })
    },
    changeLan() {
      this.$i18n.locale = this.language;
      localStorage.setItem("defaultLocale", this.language);
      document.documentElement.lang = this.language;
    },
		async init(){
			const slug = this.isPaymentStatus ? this.$store.getters.restaurantSlug : lastURLPart;
			const res = await this.$store.dispatch("restaurant/getRestaurantIdBySlug", slug);
			if (res?.type === 'error') {
				this.showRestaurant = true;
				return;
			}

			// set global variable for orderiom-api-package
			window.dynamicData = {VUE_APP_RESTAURANT_ID: this.restaurantId};
			await this.$store.dispatch("restaurant/getRestaurantInfo", this.restaurantId)

			this.$store.dispatch('fetchLegalInfo');

			this.showRestaurant = true;

			// loading uses color info
			this.enableInterceptor();

			!window.isLocaleSetByBrowser && this.changeLan()

			// NOTE: It is not recommended to set meta tags client side
			this.createMetaTags();

			const lastVisit = window.localStorage.getItem('visited');
			const params = Object.fromEntries(new URLSearchParams(window.location.search));
			const today = new Date().toISOString().slice(0, 10);
			this.$store.dispatch('restaurant/recordTheVisit', {
				qrCode: Boolean(params.tableId || params.tableName || params.qrcode),
				restaurantId: this.restaurantId,
				unique: !lastVisit || lastVisit !== today,
				new: !lastVisit
			}).then(res => {
				if (!res) return;
				window.localStorage.setItem('visited', today);
			})
		}
  },
  async created() {
		this.$defineInterceptors({$store: this.$store});
    document.addEventListener('swUpdated', this.updateAvailable, { once: true })

		if(!this.isPaymentStatus){
			this.init();
		}
		else {
			this.$watch("$store.getters.restaurantSlug", (newVal) => {
				if(!newVal) return;
				this.init();
			});
			this.showRestaurant = true;
		}
  },
};
</script>

<style>
@import "@/assets/css/index.css";
@import "@/assets/css/ql-editor.css";
</style>
